import { useEffect, useRef, useState } from "react";
import { useReducedMotion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, className = "" }) => {
  const ref = useRef(null);
  const reduceMotion = useReducedMotion();
  const [visible, setVisible] = useState(reduceMotion);

  useEffect(() => {
    const element = ref.current;
    if (!element || reduceMotion) {
      setVisible(true);
      return undefined;
    }

    if (!("IntersectionObserver" in window)) {
      setVisible(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin: "0px 0px -60px 0px", threshold: 0.08 }
    );

    observer.observe(element);
    return () => observer.disconnect();
  }, [reduceMotion]);

  return (
    <div
      ref={ref}
      className={`reveal ${visible ? "is-visible" : ""} ${className}`}
      style={{ transitionDelay: reduceMotion ? "0ms" : `${delay}s` }}
    >
      {children}
    </div>
  );
};
